import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';

import { Keys } from '@holmescorp/common';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { I18nProperties, DefaultChildrenWNodeFactory } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { publish } from '@holmescorp/pub-sub';

import css from '../css/resource-parser.m.css';
import { includes } from 'lodash-es';

export interface ResourceLinkProperties {
	xqa: string;
	action: string;
	flags?: string[];
}

const factory = create({ theme }).properties<ResourceLinkProperties>();
export const ResourceLink = factory(({ children, properties, middleware: { theme } }) => {
	const { key, xqa, action, flags = [] } = properties();
	const themeCss = theme.classes(css);
	const role = includes(flags, 'ariaRoleListitem') ? 'listitem button' : 'button';
	return v(
		'span',
		{
			key,
			xqa,
			tabIndex: 0,
			role,
			classes: [themeCss.resourcelink],
			onclick: (event) => {
				event.stopPropagation();
				publish(action);
			},
			onkeydown: (event) => {
				switch (event.key) {
					case Keys.Enter:
					case Keys.Space:
					case Keys.Spacebar:
						event.preventDefault();
						publish(action);
				}
			}
		},
		children()
	);
});
